import { render, staticRenderFns } from "./asks.vue?vue&type=template&id=3462f773&"
import script from "./asks.vue?vue&type=script&lang=js&"
export * from "./asks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports